import React from "react";

import { useTranslation } from "react-i18next";

import dancingCouple from "../../assets/images/elements/dancing-couple.svg";
import logoImage from "../../assets/images/elements/headerLogo.svg";
import { I18N_NAMESPACES } from "../../helpers/constants";
import {
  StyledContainer,
  StyledHeader,
  StyledHeaderLogoImage,
  StyledInnerContainer,
  MessageContainer,
  StyledText,
  StyledParagraph,
  StyledImg,
} from "./style";

/**
 * Maintenance page displayed when the website-under-maintenance feature flag is enabled.
 * */
const Maintenance: React.FC = () => {
  const { t } = useTranslation(I18N_NAMESPACES.COMMON);

  return (
    <StyledContainer height={window.innerHeight}>
      <StyledHeader>
        <StyledHeaderLogoImage src={logoImage} alt="Good Pair Days" />
      </StyledHeader>
      <StyledInnerContainer>
        <MessageContainer>
          <StyledText>{t("common:maintenance.header")}</StyledText>
          <StyledParagraph>{t("common:maintenance.paragraph")}</StyledParagraph>
        </MessageContainer>
        <StyledImg src={dancingCouple} alt="website-under-maintenance" />
      </StyledInnerContainer>
    </StyledContainer>
  );
};

export default Maintenance;
